import React, { useState } from 'react';
import {
  checkedYellow,
  uncheckedGrey,
  checkedGreen,
  arrDown,
  arrUp,
  playBtn,
  uncheckedWhite,
} from '../../assets/images/dashboard-business';
import { TDirectorInfo, TStep3Branch } from '../../types';
import { validateShareholder } from '../../utils/ValidateShareholderInfo';

type TProps = {
  steps: string[];
  active: number;
  shareholders?: TDirectorInfo[];
  businessAddress?: TStep3Branch[];
  instructions?: string[];
  step: number;
  currentBranch?: number;
  display: number;
  currentShareholder?: number;
  handleClick: (index: number) => void;
  setStep: React.Dispatch<React.SetStateAction<number>>;
};
const SideBar = ({
  steps,
  step,
  businessAddress,
  shareholders,
  setStep,
  handleClick,
  instructions = [],
  currentBranch,
  display,
  currentShareholder = 0,
}: TProps) => {
  const [expand, setExpand] = useState(false);
  const iterations = businessAddress ?? shareholders;
  const instructionsToDisplay = !expand ? instructions?.slice(0, 2) : instructions;
  const completedSteps: boolean[] = JSON.parse(localStorage.getItem('completed-steps1') ?? '[]');

  const imgToDisplay = (index: number) => {
    if (Number(step) === index + 1) {
      return playBtn;
    } else if (completedSteps[index]) {
      return checkedGreen;
    } else {
      return uncheckedGrey;
    }
  };

  const background = (index: number) => {
    if (Number(step) === index + 1) {
      return 'rgba(248, 180, 0, 0.37)';
    } else if (completedSteps[index]) {
      return 'rgba(248, 180, 0, 0.37)';
    } else {
      return 'rgba(118, 131, 150, 0.1)';
    }
  };

  const handleClickSidebar = (index: number) => {
    if (index === 0) {
      setStep(index + 1);
    } else {
      if (completedSteps[index - 1]) {
        setStep(index + 1);
      }
    }
  };

  return (
    <div
      className='lg:w-[20%] lg:min-h-[100%] lg:min-w-[200px] lg:max-w-[235px] lg:pt-[60px] pb-3 pt-[30px]'
      style={{ backgroundColor: 'rgba(248, 180, 0, 0.07)' }}
    >
      {!!shareholders?.length &&
        (step === 4 || step === 5) &&
        [...shareholders]?.map((_, index) => (
          <div
            className='bg-[#028789] flex justify-between p-3 mt-2 text-xs text-[white] cursor-pointer'
            key={index}
            onClick={() => handleClick(index)}
          >
            <div>
              {shareholders[index]?.firstName && shareholders[index]?.lastName
                ? `${shareholders[index]?.firstName} ${shareholders[index]?.lastName} ${
                    index === 0 ? '(Chairman)' : index === 1 ? '(Secretary)' : '(Member)'
                  }`
                : `${step === 4 ? 'Trustees' : 'Director'} - ${index + 1}`}
            </div>
            <img
              src={validateShareholder(shareholders, index, step) ? checkedYellow : uncheckedWhite}
              alt='checked'
            />
          </div>
        ))}

      {(step === 4 || step === 5) &&
        !shareholders?.[currentShareholder] &&
        currentShareholder !== -1 && (
          <div className='bg-[#028789] flex justify-between p-3 mt-2 text-xs text-[white]'>
            <div>{`${step === 4 ? 'Trustee' : 'Director'} - ${currentShareholder + 1}`}</div>
            <img src={uncheckedWhite} alt='checked' />
          </div>
        )}
      {!!iterations?.length && (
        <div className='my-4 mx-3 h-[1px] bg-[#212121]'>
          <hr />
        </div>
      )}
      <div>
        <div
          className='pl-3 mt-3'
          style={{
            color: '#005555',
            fontSize: '18px',
            fontWeight: '600',
            lineHeight: '27px',
            marginBottom: '20px',
          }}
        >
          Application Steps
        </div>
        <div className='pl-3 font-[500] text-xs'>
          You can always click on any button to go back and edit any section
        </div>

        <div className='mt-3'>
          {steps.map((step, index) => (
            <div
              style={{
                backgroundColor: background(index),
              }}
              className='p-3 flex justify-between mb-2 text-[#005555] text-xs items-center cursor-pointer'
              key={index}
              onClick={() => handleClickSidebar(index)}
            >
              <div>{`${index + 1}. ${step}`}</div>
              <img src={imgToDisplay(index)} alt='' />
            </div>
          ))}

          {completedSteps[3] && completedSteps[2] && (
            <div
              style={{
                backgroundColor: 'rgba(248, 180, 0, 0.37)',
              }}
              className='p-3 flex justify-between mb-2 text-[#005555] text-xs items-center cursor-pointer'
              onClick={() => handleClickSidebar(4)}
            >
              <div>{`5. Preview`}</div>
              <img src={checkedGreen} alt='' />
            </div>
          )}
        </div>
      </div>

      {instructions?.length > 0 && (
        <div className='pl-3 mt-5 mb-2'>
          <span className='text-xs font-[600] leading-[18px] border-b-2 border-[#000000]'>
            How to get business names approved by CAC
          </span>
        </div>
      )}
      {instructions?.length > 0 &&
        instructionsToDisplay?.map((instruction, index) => (
          <div className='px-3 flex gap-2 items-start' key={index}>
            <img src={checkedYellow} className='h-3 w-3' />
            <div className='text-[#000000] text-xs mb-2'>{instruction}</div>
          </div>
        ))}
      {instructions?.length > 0 && (
        <div
          className='ml-2 text-[#028789] pl-3 text-xs cursor-pointer'
          onClick={() => setExpand(!expand)}
        >
          {expand ? `Collapse to read less ` : 'Expand to read more '}
          <img alt='' src={expand ? arrUp : arrDown} />
        </div>
      )}
    </div>
  );
};

export default SideBar;
